/* Vanity Babe theme — native Shopify cart (AJAX API), drawers, product variants, predictive search */
(function () {
  'use strict';
  var VB = window.VB || {};
  var S = VB.strings || {};

  function formatMoney(cents) {
    var value = (cents / 100);
    var fmt = VB.moneyFormat || '{{amount}}';
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimals ? decimal : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(value, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.style.overflow = 'hidden';
    var focusTarget = el.querySelector('input[type=search]') || el.querySelector('button');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
    if (id === 'CartDrawer') refreshCart();
    return true;
  }
  function closeDrawers() {
    document.querySelectorAll('[data-drawer]').forEach(function (d) { d.hidden = true; });
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) {
      if (opener.dataset.openDrawer === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      if (openDrawer(opener.dataset.openDrawer)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeDrawers(); }
    var menu = e.target.closest('[data-menu-toggle]');
    if (menu) {
      var nav = document.getElementById('MobileNav');
      var open = nav.classList.toggle('is-open');
      menu.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart ---------- */
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = n === 0; });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    var lines = document.querySelector('[data-cart-lines]');
    var summary = document.querySelector('[data-cart-summary]');
    if (!lines) return;
    if (!cart.items.length) {
      lines.innerHTML = '<div class="drawer-empty">' + esc(S.empty) + '</div>';
      if (summary) summary.hidden = true;
      return;
    }
    if (summary) summary.hidden = false;
    lines.innerHTML = cart.items.map(function (item, i) {
      var img = item.image ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2').split('?')[0] + '?width=200') + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '<span></span>';
      var variant = item.product_has_only_default_variant ? '' : '<p class="line-variant">' + esc(item.variant_title) + '</p>';
      return '<div class="cart-line" data-line="' + (i + 1) + '">' +
        '<a href="' + esc(item.url) + '">' + img + '</a>' +
        '<div><h4><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h4>' + variant +
        '<p class="line-price">' + formatMoney(item.final_line_price) + '</p></div>' +
        '<div class="line-controls"><button type="button" class="line-remove" data-line-change="0">' + esc(S.remove) + '</button>' +
        '<div class="qty"><button type="button" aria-label="-" data-line-change="' + (item.quantity - 1) + '">−</button><span>' + item.quantity + '</span>' +
        '<button type="button" aria-label="+" data-line-change="' + (item.quantity + 1) + '">+</button></div></div></div>';
    }).join('');
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }
  function refreshCart() {
    return fetch(VB.routes.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    var line = btn.closest('[data-line]');
    var lines = document.querySelector('[data-cart-lines]');
    lines.classList.add('is-loading');
    fetch(VB.routes.cartChange, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line.dataset.line), quantity: Math.max(0, Number(btn.dataset.lineChange)) })
    }).then(function (r) { return r.json(); }).then(renderCart).finally(function () { lines.classList.remove('is-loading'); });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    var button = form.querySelector('[type=submit]');
    var original = button ? button.textContent : '';
    var errorEl = form.querySelector('[data-form-error]');
    if (button) { button.disabled = true; button.classList.add('is-loading'); }
    if (errorEl) errorEl.hidden = true;
    fetch(VB.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');
        if (button) button.textContent = S.added;
        return refreshCart().then(function () { if (!button || !button.closest('.product-card')) openDrawer('CartDrawer'); else openDrawer('CartDrawer'); });
      })
      .catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { alert(err.message); }
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          setTimeout(function () { button.textContent = original; button.disabled = false; }, 1600);
        }
      });
  });

  /* ---------- Product page ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var json = section.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-button]');
    var priceEl = section.querySelector('[data-price]');
    var availEl = section.querySelector('[data-availability]');
    var mainImg = section.querySelector('[data-main-media] img');

    function setMain(src) { if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = src; } }
    section.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        section.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        setMain(t.dataset.src);
      });
    });

    section.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = section.querySelector('[data-qty-input]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep));
      });
    });

    function selected() {
      var values = [];
      section.querySelectorAll('[data-option-index]:checked').forEach(function (r) { values[Number(r.dataset.optionIndex)] = r.value; });
      return values;
    }
    function update() {
      var values = selected();
      var variant = product.variants.find(function (v) { return v.options.every(function (o, i) { return o === values[i]; }); });
      values.forEach(function (v, i) { var lbl = section.querySelector('[data-option-value="' + i + '"]'); if (lbl) lbl.textContent = v; });
      if (!variant) {
        addBtn.disabled = true; addBtn.textContent = S.unavailable;
        if (availEl) availEl.textContent = S.unavailable;
        return;
      }
      idInput.value = variant.id;
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? S.addToBag : S.soldOut;
      if (availEl) availEl.textContent = variant.available ? (availEl.dataset.inStock || availEl.textContent.trim() === S.soldOut ? 'In stock' : availEl.textContent) : S.soldOut;
      if (priceEl) {
        var html = formatMoney(variant.price);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += ' <s class="compare-price">' + formatMoney(variant.compare_at_price) + '</s>';
          priceEl.classList.add('is-sale');
        } else { priceEl.classList.remove('is-sale'); }
        priceEl.innerHTML = html;
      }
      if (variant.featured_media && variant.featured_media.preview_image) {
        setMain(variant.featured_media.preview_image.src + (variant.featured_media.preview_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1400');
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    if (form) form.addEventListener('change', function (e) { if (e.target.matches('[data-option-index]')) update(); });
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Collection filters ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });

  /* ---------- Predictive search ---------- */
  var input = document.querySelector('[data-predictive-input]');
  var results = document.querySelector('[data-predictive-results]');
  var timer;
  if (input && results) {
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch(VB.routes.predictive + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { results.innerHTML = '<div class="drawer-empty">' + esc(S.noResults) + '</div>'; return; }
            results.innerHTML = products.map(function (p) {
              var img = p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '';
              return '<a class="search-result" href="' + esc(p.url) + '">' + img + '<div><strong>' + esc(p.title) + '</strong><span>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></div></a>';
            }).join('');
          }).catch(function () {});
      }, 300);
    });
  }
})();
